/**
 * Event emitter class and utilities
 *
 * @copyright 2018 Linguistica 360
 */


import ee from 'event-emitter';


export class EventEmitter { }

ee(EventEmitter.prototype);
